import React, { useEffect, useState } from 'react';
import { getUser, hasUserLoggedIn, isLoggedIn, logout, handleLogin } from '../services/auth';
import { useGoogleLogin, useGoogleLogout } from 'react-google-login';
import { Box, Menu, MenuButton, MenuList, MenuItem } from '@houzz/ui';

const options = {
    clientId: '81258383996-9bu0g5hdfnrdonqo3edrr47oj1n1j2ke.apps.googleusercontent.com',
    cookiePolicy: 'single_host_origin',
    hostedDomain: 'houzz.com',
};

const HouzzAvatar = () => {
    const [, updateState] = useState({});
    const _hasUserLoggedIn = hasUserLoggedIn();
    const _isLoggedIn = isLoggedIn();
    const user = getUser();

    // eslint-disable-next-line no-unused-vars
    const { signOut, loaded: signOutLoaded } = useGoogleLogout({
        onFailure: () => {
            updateState({});
        },
        onLogoutSuccess: () => {
            logout();
            updateState({});
        },
        ...options,
    });

    // eslint-disable-next-line no-unused-vars
    const { signIn, loaded: signInLoaded } = useGoogleLogin({
        onFailure: () => {
            logout();
            updateState({});
        },
        onSuccess: (...args) => {
            handleLogin(args);
            updateState({});
        },
        ...options,
    });

    useEffect(() => {
        if (_hasUserLoggedIn && !_isLoggedIn) {
            signIn();
        }
    }, [_isLoggedIn, _hasUserLoggedIn, signIn]);

    if (!user || !user.name) {
        return null;
    }

    return (
        <Box display="flex" borderRadius="round">
            <Menu placement="bottom-end">
                <MenuButton variant="link" icon={null}>
                    <Box
                        as="img"
                        width="32"
                        height="32"
                        borderRadius="round"
                        src={user.imageUrl}
                        alt={`Avatar for ${user.name}`}
                    />
                </MenuButton>
                <MenuList>
                    <MenuItem onClick={signOut}>Sign Out</MenuItem>
                </MenuList>
            </Menu>
        </Box>
    );
};

export default HouzzAvatar;
